<template>
    <div>
        <SummaryPlaceholders v-show='!product.product'/>
        
        <div class='summary-container' v-show='product.product'>
            <div v-show='product.product' class='product-title'>{{product.product}}</div>
            <div class='price-container'>
                <!-- <div class='price price-slashed'>£{{product.price}}</div> -->
                <div class='price'>£{{product.price}}</div>
            </div>
            <div class='product-code'>
                Product code: #{{product_code}}
            </div>
            <div class='ratings-container'>
                <Ratings :rating='average_rating' :number_of_reviews='total_reviews' @click='goToReviews'/>
            </div>
            <Separator/>
            <!-- <div class='details'>{{product.details}}</div> -->
        </div>
    </div>
</template>

<script>
import Ratings from '@/ecom/components/products/single_product/reviews/Ratings.vue';
import Separator from '@/ecom/components/separators/Separator.vue';
import SummaryPlaceholders from '@/ecom/components/products/single_product/details/SummaryPlaceholders.vue';

export default {
    components: {Ratings, Separator, SummaryPlaceholders},
    props: ['product', 'average_rating', 'total_reviews', 'variant_code', 'product_on_popout'],
    data(){
        return{
            product_code: ''
        }
    },
    methods:{
        goToReviews(){
            if(!this.product_on_popout){
                const y_offset = 600; 
                const element = document.getElementById('product-reviews-scroll');
                const y = element.getBoundingClientRect().top + window.pageYOffset + y_offset;
                
                window.scrollTo({top: y, behavior: 'smooth'});
            }
            else{
                const element = document.getElementById('product_popout_reviews_container');
                const y = element.getBoundingClientRect().top;
                document.getElementById('basket_popout').scrollTo({top: y, behavior: 'smooth'});
            }
        }
    },
    watch:{
        'product' : function(){
            this.product_code = this.product.code;
        },
        'variant_code' : function(){
            this.product_code = this.variant_code;
        }
    }
}
</script>

<style lang="scss" scoped>
.summary-container{
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.product-title{
    font-size: 1.4rem;
    color: var(--black);
}

.price-container{
    display: flex;
    gap: 10px;
    align-items: center;
}

.price{
    font-size: 1.4rem;
}

.price-slashed{
    text-decoration: line-through;
    font-size: 1.3rem;
    color: #737373;

}

.ratings-container{
    cursor: pointer;
}

.details{
    // max-width: 500px;
}

.favourite{
    font-size: 1.2rem;
    color: #fa5252;
}

.product-code{
    color: #737373;

}
</style>